import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ItemOutCP } from '../../../../models/item-out-model';

@Component({
    standalone: false,
    selector: 'por-contract-detail-renderer',
    templateUrl: './contract-detail-renderer.component.html',
    styleUrls: ['./contract-detail-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractDetailRendererComponent implements ICellRendererAngularComp, AfterViewInit {
    private readonly cdref = inject(ChangeDetectorRef);

    cellValue!: string;

    public params!: ICellRendererParams;
    private itemOut!: ItemOutCP;

    ngAfterViewInit(): void {
        this.cdref.detectChanges();
    }
    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        this.cellValue = this.getValueToDisplay(params);
        this.params = params;
        this.itemOut = params.data;
    }

    // gets called whenever the user gets the cell to refresh
    refresh(params: ICellRendererParams) {
        // set value into cell again
        this.cellValue = this.getValueToDisplay(params);
        return true;
    }

    loadContractDetail() {
        this.params.context?.componentParent.loadContractDetail(this.itemOut.contractId);
    }

    getValueToDisplay(params: ICellRendererParams) {
        return params.valueFormatted ? params.valueFormatted : params.value;
    }
}
